import { Box, Typography } from '@mui/material';
import React from 'react';
type PropTypes = {
  message: string | null;
  type?: 'error';
};

export default function MessageDisplay(props: PropTypes) {
  const { message, type = 'error' } = props;

  let color;
  if (type === 'error') {
    color = '#c90000';
  }

  return (
    <Box
      alignItems={'center'}
      display={'flex'}
      justifyContent={'center'}
      sx={{ height: '100vh', backgroundColor: '#e5e5e5' }}
    >
      <Typography color={color} fontWeight={'600'} variant="h4">
        {message}
      </Typography>
    </Box>
  );
}
